import { useState, useEffect, useContext } from 'react';
import callContext from '@/pages/crm/callCenter/callManage/callManageContext'
import { Spin, Empty, Upload, Button, message, Form } from 'antd'
import styles from '../../index.module.less';

import { baseURL } from '@/api'
import { getToken } from '@/common/utils'
import { getAudioRecordList, addAudio } from '@/services/callCenter'
import { UploadOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { getXTransferInsideTenantId } from '@/utils/common';
function CallRecord() {
  const { callManageState } = useContext(callContext)
  const { detailParameter, callDetails } = callManageState
  const [loading, setLoading] = useState(false);

  const [refresh, setRefresh] = useState(false); //刷新数据
  const [list, setList] = useState([])

  useEffect(() => {
    getCallRecord();
  }, [detailParameter.id, refresh]);

  // 获取通话记录数据
  const getCallRecord = () => {
    if (!detailParameter.id || loading) return;
    setLoading(true);
    getAudioRecordList(1, 999, { clueId: detailParameter.id })
      .then((res: any) => {
        setList(res?.list || [])
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const uploadProps = {
    accept: '.mp3',
    action: baseURL + '/file-web/fileStore/upload',
    headers: { "Authorization": getToken(), 'X-Transfer-Inside-Tenant-Id': getXTransferInsideTenantId() },
    maxCount: 1,
    beforeUpload(file: any) {
      const type = file.name.split('.').slice(-1).join().toLowerCase();
      const isMP3 = ['mp3'].includes(type);
      const isLt20M = file.size / 1024 / 1024 < 20;
      if (!isMP3) {
        message.error('请上述.xls或.xlsx类的的文件');
        return Upload.LIST_IGNORE;
      }
      if (!isLt20M) {
        message.error('上传文件大小不能超过20M');
        return Upload.LIST_IGNORE;
      }
      return isMP3 && isLt20M;
    },
    onChange: (v) => {
      if (v?.file?.status == 'error') {
        message.error(v.file.response.message)
      } else if (v?.file?.status == 'done') {
        const res = v?.file?.response?.data?.url || ''
        getTimes(res)
      }
    }
  }
  const getTimes = (url) => {
    const audioE = document.createElement("audio"); // 获取时长
    audioE.src = url;
    audioE.load();
    audioE.oncanplay = function () {
      addAudio({
        cludId: detailParameter.clueId,
        path: url,
        timeLength: Math.floor(audioE.duration),
      }).then((res) => {
        setRefresh(!refresh)
      })
    }
  }
  const listItme = (data: any, index: any) => {
    return (
      <div className={styles.callRecordItem} key={index}>
        <div className={styles.itemRow}>
          <div className={styles.itemRowTitle}>呼叫状态</div>
          <div className={styles.itemRowContent}>
            【{data.callTypeName}】【{data.callStateName}】
          </div>
        </div>
        <div className={styles.itemRow}>
          <div className={styles.itemRowTitle}>通话录音</div>
          <div className={styles.itemRowContent}>
            {data.monitorFileName ? (
              <audio
                src={data.monitorFileName}
                controls
              >
                浏览器不支持音频播放。
              </audio>
            ) : (
              '无'
            )}
          </div>
        </div>
        <div className={styles.itemRow}>
          <div className={styles.itemRowTitle} style={{ textAlign: 'center' }}>
            <div className={styles.headShot}></div>
          </div>
          <div className={styles.itemRowContent}>
            <div>{`${data.agentName} ( ${data.tenantName || ''}) `}</div>
            <div style={{ marginLeft: '20px' }}>{data?.ring ? dayjs(data.ring).format('YYYY-MM-DD HH:mm:ss') : ''}</div>
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className={styles.CallRecord}>
      <div>
        {callDetails.clueStatusName === '信息' ?
          (
            <div >
              <Form.Item extra="支持格式：.mp3，单个文件不能超过20MB" style={{ margin: '10px 12px' }}>
                <Upload {...uploadProps}>
                  <Button icon={<UploadOutlined />}>上传录音</Button>
                </Upload>
              </Form.Item>
            </div>
          ) : null
        }
        <div className={styles.callList}>
          <div className={styles.callTitle}>通话记录</div>
          <Spin tip="Loading" size="small" spinning={loading}>
            {list.length ? list.map((d: any, i: any) => listItme(d, i)) : null}
            <div className={styles.callLoading}>
              {!list.length ? (
                !loading ? (
                  <Empty />
                ) : null
              ) : (
                <div>没有更多了</div>
              )}
            </div>
          </Spin>
        </div>
      </div>
    </div>
  );
}

export default CallRecord;
